// extracted by mini-css-extract-plugin
export default {"title":"Liked_title__8mQux","likedContainer":"Liked_likedContainer__IRkTI","noLikedItems":"Liked_noLikedItems__Wn8Uv","sadIcon":"Liked_sadIcon__gHzCF"};